import { render, staticRenderFns } from "./wyModalAddObjective.vue?vue&type=template&id=29006c83&"
import script from "./wyModalAddObjective.vue?vue&type=script&lang=js&"
export * from "./wyModalAddObjective.vue?vue&type=script&lang=js&"
import style0 from "./wyModalAddObjective.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports